/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  map.set(pair[0], pair[1]);
  return map;
}

module.exports = addMapEntry;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/_addMapEntry.js
 ** module id = 88
 ** module chunks = 0
 **/